<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // "belum_ada" | "draft" | "selesai", dipakai untuk menentukan tombol & teks info yang tampil
    statusPemilihan: {
      type: String,
      default: null,
    },
    approving: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["ubah-kompetensi", "approve"],
};
</script>

<template>
  <div>
    <div class="alert alert-info fw-bold d-flex justify-content-between align-items-center">
      <div>
        <i class="fa fa-info-circle text-primary me-1"></i>
        <template v-if="statusPemilihan === 'selesai'">
          HCBP sudah melakukan approve untuk data ini.
        </template>
        <template v-else>
          Pegawai sudah memilih kompetensi berikut, silakan periksa dan approve bila sudah sesuai.
        </template>
      </div>

      <div v-if="statusPemilihan !== 'selesai'">
        <button
          type="button"
          class="btn btn-primary btn-sm fw-bold me-2"
          :disabled="approving"
          @click="$emit('ubah-kompetensi')"
        >
          <i class="fas fa-pen me-1"></i>
          Ubah Kompetensi
        </button>
        <button
          type="button"
          class="btn btn-success btn-sm fw-bold"
          :disabled="approving"
          @click="$emit('approve')"
        >
          <i class="fas fa-spinner fa-spin me-1" v-if="approving"></i>
          <i class="fas fa-check me-1" v-else></i>
          Approve
        </button>
      </div>
    </div>

    <fieldset
      class="border p-3 rounded"
      style="border-color: #e5e7eb !important"
    >
      <legend class="float-none w-auto px-1 fs-5">
        Kompetensi Terpilih ({{ list.length }})
      </legend>

      <div v-if="loading" class="text-center py-3">
        <i class="fas fa-spinner fa-spin me-1"></i> Memuat kompetensi...
      </div>
      <div
        v-else-if="list.length === 0"
        class="alert alert-secondary fw-bold mb-0"
      >
        Tidak ada kompetensi yang tercatat.
      </div>
      <div
        v-else
        v-for="(item, index) in list"
        :key="item.idkompetensi"
        class="mym-competency-card mb-3"
      >
        <div class="mym-competency-header">
          <div class="mym-number">{{ index + 1 }}</div>

          <div class="mym-competency-content">
            <div class="mym-competency-title">
              {{ item.nama_kompetensi }}
            </div>

            <div class="mym-tags">
              <span class="mym-small-badge mym-soft-badge-primary text-nowrap">
                <i class="fas fa-barcode me-1"></i>
                {{ item.kode_kompetensi }}
              </span>
              <span class="mym-small-badge mym-soft-badge-secondary text-nowrap">
                Level {{ item.level_kompetensi }}
              </span>
              <span
                v-if="item.terpilih_otomatis"
                class="mym-small-badge mym-badge-dark py-1 px-3 text-nowrap"
              >
                <i class="fas fa-magic me-1"></i> Otomatis
              </span>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
